import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback({ onAuthenticated }) {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }
    const session_id = match[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        if (onAuthenticated) onAuthenticated(data);
        // Clear the hash and go to dashboard
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard", { state: { user: data } });
      } catch (e) {
        setError("Google sign-in failed. Please try again.");
        setTimeout(() => navigate("/login"), 1500);
      }
    })();
  }, [navigate, onAuthenticated]);

  return (
    <div className="min-h-screen flex items-center justify-center starfield" data-testid="auth-callback-page">
      <div className="glass-strong rounded-2xl p-10 text-center">
        <div className="text-gold font-serif text-2xl mb-2">Aligning the stars...</div>
        <div className="text-slate-400">{error || "Completing your Google sign-in"}</div>
      </div>
    </div>
  );
}
